// src/ThemeProviderWrapper.jsx
import React, { useEffect } from "react";
import { ThemeProvider } from "./theming";

const ThemeProviderWrapper = ({ children, theme }) => {
  useEffect(() => {
    const root = document.documentElement;
    root.style.setProperty("--color-accent", theme.accentColor || "#3D5C40");
    root.style.setProperty("--color-background", theme.backgroundColor || "#F5F2ED");
    root.style.setProperty("--color-text-primary", theme.textColor || "#2C3E2D");
    root.style.setProperty("--color-text-secondary", theme.secondaryColor || "#A8BFA9");
    root.style.setProperty("--color-charcoal", theme.charcoal || "#333333");
    root.style.setProperty("--font-family-sans", theme.fontSans || "Lato, sans-serif");
    root.style.setProperty("--font-family-serif", theme.fontSerif || "Playfair Display, Georgia, serif");
  }, [theme]);

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};

export default ThemeProviderWrapper;
